import { render, staticRenderFns } from "./LayoutAccess.vue?vue&type=template&id=79b20d6e&"
import script from "./LayoutAccess.vue?vue&type=script&lang=js&"
export * from "./LayoutAccess.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAccess.vue?vue&type=style&index=0&id=79b20d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports